<template>
  <div class="bb-home-m">
    <div class="bb-home-main">
      <section class="bb-m-hero" v-if="!isLogin">
        <div class="bb-m-banner">
          <img src="@/assets/ui/h5/H5-banners.webp" alt="" />
          <div class="bb-m-fade"></div>
        </div>
        <div class="bb-m-copy">
          <div class="bb-m-titles">
            <h1>{{ $t("home.h5Slogan") }}</h1>
            <p>
              <img src="@/assets/ui/h5/gift-h5-white.svg" alt="" />
              {{ $t("home.h5GiftPrefix") }}
              <span class="bb-m-gift">{{ $t("home.h5GiftAmount") }}</span>
              {{ $t("home.h5GiftSuffix") }}
            </p>
          </div>
          <button type="button" @click="goRegister">
            <svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M12.5026 2C13.8833 2 15.0026 3.11934 15.0026 4.5C15.0026 5.06344 14.8142 5.58193 14.4997 6H17.405C18.2885 6 19.0053 6.71616 19.0056 7.59961V9.2002H17.0046V16.4004C17.0044 17.2839 16.2885 18 15.405 18H4.60516C3.72179 17.9998 3.00477 17.2838 3.00458 16.4004V9.2002H1.00555V7.59961C1.0058 6.71618 1.72169 6.00004 2.60516 6H5.50555C5.19106 5.58193 5.00262 5.06344 5.00262 4.5C5.00269 3.11934 6.12195 2 7.50262 2C8.8833 2 10.0026 3.11934 10.0026 4.5C10.0027 3.11934 11.122 2 12.5026 2ZM9.00751 16H11.0075V10H9.00751V16Z"
                fill="currentColor"
              />
            </svg>
            {{ $t("navTab.btnSignup") }}
          </button>
        </div>
      </section>

      <section class="bb-m-logged" v-else>
        <div class="bb-m-asset">
          <div class="bb-m-asset-copy">
            <div class="bb-m-asset-label">
              <span>{{ $t("home.totalAsset") }}</span>
              <button type="button" @click="hideAsset = !hideAsset">
                <svg v-if="!hideAsset" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path fill="currentColor" d="M7.01554 4.82385C8.21007 4.82394 9.17891 5.79236 9.17912 6.98686L9.17627 7.09851C9.1183 8.24143 8.17285 9.15035 7.01554 9.15043L6.90446 9.14758C5.76148 9.08963 4.85254 8.14424 4.85254 6.98686C4.85275 5.79239 5.82106 4.824 7.01554 4.82385ZM7.01554 5.99052C6.46539 5.99066 6.01942 6.43672 6.01921 6.98686C6.01921 7.53717 6.46526 7.98362 7.01554 7.98377C7.56588 7.98368 8.01245 7.53721 8.01245 6.98686C8.01224 6.43669 7.56575 5.99061 7.01554 5.99052Z" />
                  <path fill="currentColor" d="M7.17562 2.67338C10.5315 2.79508 13.3882 6.69304 13.3895 6.99996L13.3809 7.03927C13.2065 7.55501 10.3558 11.3037 7.01554 11.3038L6.85433 11.3009C3.47782 11.1812 0.642811 7.35058 0.641602 6.99996C0.64278 6.64384 3.59083 2.67064 7.01554 2.67053L7.17562 2.67338ZM7.01554 3.8372C5.73195 3.83726 4.41032 4.60249 3.32015 5.57353C2.7937 6.04246 2.36547 6.52035 2.07544 6.89172C2.0464 6.92891 2.02006 6.96542 1.99455 6.99939C2.01919 7.03216 2.04408 7.06785 2.07202 7.10364C2.35987 7.4721 2.78545 7.94673 3.3099 8.41215C4.39438 9.37452 5.71731 10.137 7.01554 10.1371C8.30965 10.1371 9.63084 9.36758 10.7183 8.39734C11.2437 7.92866 11.6711 7.45158 11.9608 7.08256C11.9829 7.05441 12.0022 7.02571 12.0223 6.99939C12.0014 6.97192 11.9805 6.94225 11.9574 6.9128C11.6655 6.54093 11.2359 6.05989 10.7087 5.58777C9.61548 4.60888 8.29498 3.83723 7.01554 3.8372Z" />
                </svg>
                <svg v-else width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path fill="currentColor" d="M1.2 1.2 12.8 12.8l-.85.85L10.4 12.1A8.5 8.5 0 0 1 7 11.3C3.48 11.18.64 7.35.64 7c.08-.27 1.18-1.72 2.7-3.05L.35 2.05 1.2 1.2Zm3.3 4.37A2.16 2.16 0 0 0 7 9.15c.35 0 .68-.08.97-.22L6.4 7.36A1.16 1.16 0 0 1 5.86 6.5L4.5 5.57ZM7 2.67c.54 0 1.07.05 1.58.16l-1.05 1.05A2.16 2.16 0 0 0 4.9 6.3L3.7 5.1C4.65 3.7 5.82 2.67 7 2.67Zm3.35 2.27 1.1-1.1c1.3 1.1 2.2 2.4 2.54 2.8-.02.03-.2.32-.43.62-.29.37-.72.85-1.24 1.32l-1.12-1.12c.4-.4.74-.82.97-1.14.02-.03.04-.06.06-.08a7.4 7.4 0 0 0-1.88-1.3Z" />
                </svg>
              </button>
            </div>
            <div class="bb-m-asset-value">
              <span>{{ hideAsset ? "******" : assetAmount }}</span>
              <em>USD</em>
            </div>
          </div>
          <button class="bb-m-add" type="button" @click="$router.push('/profile/deposit')">{{ $t("home.addFunds") }}</button>
        </div>
        <div class="bb-m-entries">
          <button type="button" @click="$router.push('/tokenSale')">
            <img src="@/assets/ui/h5/entry-buy.png" alt="" />
            <span>{{ $t("home.buyCoin") }}</span>
          </button>
          <!-- <button type="button" @click="$router.push('/profile/invite')">
            <img src="@/assets/ui/h5/entry-welfare.png" alt="" />
            <span>{{ $t("home.welfare") }}</span>
          </button> -->
          <button type="button" @click="$router.push('/profile/invite')">
            <img src="@/assets/ui/h5/entry-invite.png" alt="" />
            <span>{{ $t("account.inviteFriends") }}</span>
          </button>
          <button type="button" @click="$router.push('/trading')">
            <img src="@/assets/ui/h5/entry-finance.png" alt="" />
            <span>{{ $t("navTab.tabMenu5") }}</span>
          </button>
          <button type="button" @click="$router.push('/market')">
            <svg viewBox="0 0 24 24" fill="none" width="24" height="24">
              <path fill="currentColor" d="M3 4.5C3 3.6716 3.67157 3 4.5 3H9.5C10.3284 3 11 3.6716 11 4.5V9.5C11 10.3285 10.3284 11 9.5 11H4.5C3.67157 11 3 10.3285 3 9.5V4.5Z" />
              <path fill="currentColor" d="M3 14.5C3 13.6716 3.67157 13 4.5 13H9.5C10.3284 13 11 13.6716 11 14.5V19.5C11 20.3285 10.3284 21 9.5 21H4.5C3.67157 21 3 20.3285 3 19.5V14.5Z" />
              <path fill="currentColor" d="M13 14.5C13 13.6716 13.6716 13 14.5 13H19.5C20.3284 13 21 13.6716 21 14.5V19.5C21 20.3285 20.3284 21 19.5 21H14.5C13.6716 21 13 20.3285 13 19.5V14.5Z" />
              <path fill="currentColor" d="M13.0201 7.70713C12.6295 7.31661 12.6295 6.68344 13.02 6.29292L16.2929 3.02007C16.6834 2.62954 17.3166 2.62954 17.7071 3.02007L20.98 6.29292C21.3705 6.68344 21.3705 7.31661 20.98 7.70713L17.7071 10.98C17.3166 11.3705 16.6834 11.3705 16.2929 10.98L13.0201 7.70713Z" />
            </svg>
            <span>{{ $t("navTab.tabMenuMore") }}</span>
          </button>
        </div>
      </section>

      <section class="bb-m-ticker" v-if="tickerList.length">
        <div class="bb-m-ticker-grid">
          <div
            class="bb-m-ticker-item"
            v-for="item in tickerList"
            :key="'t-' + (item.id || item.code)"
            @click="toDetail(item)"
          >
            <div class="bb-m-ticker-top">
              <div class="bb-m-ticker-meta">
                <span>{{ pairBase(item) }}</span>
                <p>{{ typeLabel(item) }}</p>
              </div>
              <svg class="bb-m-spark" viewBox="0 0 40 18" width="40" height="18" aria-hidden="true">
                <polyline fill="none" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" :stroke="sparkColor(item.zdf)" :points="sparkPoints(item, 40, 18)" />
              </svg>
            </div>
            <div class="bb-m-ticker-bottom">
              <span class="bb-m-ticker-price">{{ item.nowPrice }}</span>
              <span class="bb-chg" :class="chgClass(item.zdf)">{{ formatChg(item.zdf) }}</span>
            </div>
          </div>
        </div>
      </section>

      <section class="bb-m-board">
        <div class="bb-m-ranks" v-if="hasMarketData">
          <div class="bb-m-rank-tabs">
            <button
              v-for="tab in rankTabs"
              :key="tab.key"
              type="button"
              :class="{ active: rankMode === tab.key }"
              @click="rankMode = tab.key"
            >
              {{ tab.label }}
            </button>
          </div>
          <div class="bb-m-type-tabs">
            <button
              v-for="(tab, index) in marketTabList"
              :key="tab.value"
              type="button"
              :class="{ active: markTypeIndex === index }"
              @click="markTypeIndex = index"
            >
              {{ tab.label }}
            </button>
          </div>
          <div class="bb-m-table">
            <div class="bb-m-thead">
              <span>{{ $t("home.pair") }}</span>
              <span>{{ $t("Market.LastPrice") }}</span>
              <span>{{ $t("home.chg24h") }}</span>
            </div>
            <div
              class="bb-m-trow"
              v-for="item in boardList"
              :key="'m-' + (item.id || item.code)"
              @click="toDetail(item)"
            >
              <div class="bb-m-pair">
                <img v-if="item.logo" :src="item.logo" alt="" />
                <div>
                  <div class="bb-m-pair-name">
                    {{ pairBase(item) }}<span>/{{ pairQuote(item) }}</span>
                  </div>
                  <p>{{ pairBase(item) }}</p>
                </div>
              </div>
              <div class="bb-m-last">
                <p>{{ item.nowPrice }}</p>
                <span>${{ item.nowPrice }}</span>
              </div>
              <div class="bb-m-pill" :class="chgClass(item.zdf)">{{ formatChg(item.zdf) }}</div>
            </div>
          </div>
          <div class="bb-m-more" @click="$router.push('/market')">
            <span>{{ $t("navTab.tabMenuMore") }}</span>
            <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
              <path d="M8.43359 3.33301L7.86816 3.89844L11.1709 7.2002H1.76758V8.7998H11.1689L7.86816 12.1006L9 13.2324L13.666 8.56543L14.2324 8L9 2.76758L8.43359 3.33301Z" />
            </svg>
          </div>
        </div>
      </section>
    </div>

    <footer class="bb-m-footer">
      <div class="bb-m-footer-brand" @click="$router.push('/')">
        <BrandLogo />
      </div>
      <div class="bb-m-acc" v-for="group in footerGroups" :key="group.key">
        <button class="bb-m-acc-btn" type="button" @click="toggleGroup(group.key)">
          <span>{{ group.title }}</span>
          <svg :class="{ open: openGroup === group.key }" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8.00017 8.78077L11.3 5.48096L12.2428 6.42376L8.00017 10.6664L3.75757 6.42376L4.70037 5.48096L8.00017 8.78077Z" fill="currentColor" />
          </svg>
        </button>
        <div class="bb-m-acc-body" v-show="openGroup === group.key">
          <a v-for="(link, i) in group.links" :key="group.key + i" @click.prevent="goFooter(link)">{{ link.name }}</a>
        </div>
      </div>
      <div class="bb-m-copy">© {{ year }} {{ $t("home.h5AppName") }}</div>
    </footer>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { listMarketByType } from "@/api/market.js";
import { getSignupPath } from "@/utils/authRedirect";
import { openCustomerService } from "@/utils/customerService";
import BrandLogo from "@/components/BrandLogo.vue";

export default {
  name: "HomeM",
  components: { BrandLogo },
  data() {
    return {
      marketByType: {},
      markTypeIndex: 0,
      rankMode: "hot",
      openGroup: "",
      hideAsset: false
    };
  },
  computed: {
    ...mapState(["isLogin"]),
    ...mapGetters(["marketWsList", "getContentList", "getMarkTypeList", "getUserInfo", "virtualStatus"]),
    signupPath() {
      return getSignupPath();
    },
    year() {
      return new Date().getFullYear();
    },
    assetAmount() {
      const info = this.getUserInfo || {};
      const raw = this.virtualStatus == 2 ? info.virtuallyAmount : info.amount;
      const num = Number(raw);
      if (isNaN(num)) return "0.00";
      return num.toFixed(2);
    },
    marketTabList() {
      return this.getMarkTypeList || [];
    },
    rankTabs() {
      return [
        { key: "hot", label: this.$t("home.hotRank") },
        { key: "gainers", label: this.$t("home.gainers") },
        { key: "new", label: this.$t("home.newListings") },
        { key: "volume", label: this.$t("home.volumeRank") }
      ];
    },
    hasMarketData() {
      return this.marketTabList.some((tab) => (this.marketByType[tab.value] || []).length);
    },
    currentTypeList() {
      const tab = this.marketTabList[this.markTypeIndex];
      return (tab && this.marketByType[tab.value]) || [];
    },
    tickerList() {
      const picked = [];
      this.marketTabList.forEach((tab) => {
        const first = (this.marketByType[tab.value] || [])[0];
        if (first) picked.push(first);
      });
      if (picked.length >= 4) return picked.slice(0, 4);
      const extra = this.currentTypeList.filter((item) => picked.indexOf(item) === -1);
      return picked.concat(extra).slice(0, 4);
    },
    boardList() {
      const list = this.currentTypeList.slice();
      if (this.rankMode === "gainers") {
        return list.sort((a, b) => Number(b.zdf) - Number(a.zdf)).slice(0, 8);
      }
      if (this.rankMode === "new") {
        return list.slice(-8).reverse();
      }
      if (this.rankMode === "volume") {
        return list.sort((a, b) => this.volumeOf(b) - this.volumeOf(a)).slice(0, 8);
      }
      return list.slice(0, 8);
    },
    footerGroups() {
      const company = (this.getContentList || [])
        .filter((item) => item.type == 1)
        .map((item) => ({ name: item.title, type: "cms", item }));
      const policy = (this.getContentList || [])
        .filter((item) => item.type == 2)
        .map((item) => ({ name: item.title, type: "cms", item }));
      return [
        {
          key: "company",
          title: this.$t("navBottom.bottomCompany"),
          links: company.concat([{ name: this.$t("account.inviteFriends"), path: "/profile/invite" }])
        },
        {
          key: "product",
          title: this.$t("navBottom.bottomProduct"),
          links: [
            { name: this.$t("navBottom.bottomProductItem1"), path: "/market" },
            { name: this.$t("navBottom.bottomProductItem4"), path: "/trading" },
            { name: this.$t("navBottom.bottomProductItem2"), path: "/loan" },
            { name: this.$t("navTab.tabMenu8"), path: "/tokenSale" }
          ]
        },
        {
          key: "support",
          title: this.$t("navBottom.bottomPolicy"),
          links: policy.concat([{ name: this.$t("home.onlineSupport"), type: "service" }])
        },
        {
          key: "service",
          title: this.$t("navTab.tabMenu1"),
          links: [
            { name: this.$t("navTab.btnSignup"), path: this.signupPath },
            { name: this.$t("navTab.tabMenu2"), path: "/market" },
            { name: this.$t("navTab.tabMenu3"), path: "/trading" }
          ]
        }
      ];
    }
  },
  watch: {
    marketWsList: {
      handler(val) {
        if (!val || !val[0]) return;
        Object.keys(this.marketByType).forEach((type) => {
          (this.marketByType[type] || []).forEach((item) => {
            val.forEach((tick) => {
              if (tick.code === item.code) {
                item.nowPrice = tick.price;
                item.zdf = tick.zdf != null ? (Number(tick.zdf) * 100).toFixed(2) : item.zdf;
                if (tick.price != null) {
                  const series = item.hundred || [];
                  const last = series.length ? series[series.length - 1] : null;
                  const lastPrice = last && typeof last === "object" ? last.price : last;
                  if (lastPrice !== tick.price) {
                    series.push(tick.price);
                    if (series.length > 100) series.shift();
                    item.hundred = series;
                  }
                }
              }
            });
          });
        });
      },
      deep: true
    }
  },
  mounted() {
    this.getListMarketByType();
  },
  methods: {
    goRegister() {
      this.$router.push(this.signupPath);
    },
    toDetail(item) {
      this.$router.push({
        path: "/trade/futures",
        query: { code: item.code, type: item.type, id: item.id }
      });
    },
    normalizeItem(item) {
      return {
        ...item,
        nowPrice: item.nowPrice || item.price,
        zdf: item.zdf != null ? (Number(item.zdf) * 100).toFixed(2) : "0.00",
        hundred: item.hundred || []
      };
    },
    pairParts(item) {
      const name = String(item.appName || item.code || "");
      if (name.includes("/")) {
        const parts = name.split("/");
        return [parts[0], parts.slice(1).join("/") || "USD"];
      }
      const quotes = ["USDT", "USDC", "USD", "BTC", "ETH"];
      const upper = name.toUpperCase();
      for (let i = 0; i < quotes.length; i++) {
        const q = quotes[i];
        if (upper.endsWith(q) && name.length > q.length) {
          return [name.slice(0, name.length - q.length), q];
        }
      }
      return [name, "USD"];
    },
    pairBase(item) {
      return this.pairParts(item)[0];
    },
    pairQuote(item) {
      return this.pairParts(item)[1];
    },
    typeLabel(item) {
      const tab = this.marketTabList.find((t) => String(t.value) === String(item.type));
      return tab ? tab.label : "";
    },
    chgClass(zdf) {
      const n = Number(zdf);
      if (n > 0) return "up";
      if (n < 0) return "down";
      return "";
    },
    formatChg(zdf) {
      const n = Number(zdf);
      if (n > 0) return "+" + zdf + "%";
      return zdf + "%";
    },
    sparkColor(zdf) {
      const style = typeof window !== "undefined" ? getComputedStyle(document.documentElement) : null;
      const up = (style && style.getPropertyValue("--bb-up").trim()) || "#44b400";
      const down = (style && style.getPropertyValue("--bb-down").trim()) || "#ff2828";
      return Number(zdf) >= 0 ? up : down;
    },
    sparkPoints(item, w, h) {
      const width = w || 40;
      const height = h || 18;
      const raw = item.hundred || [];
      const values = raw
        .map((p) => (p && typeof p === "object" ? Number(p.price) : Number(p)))
        .filter((n) => !isNaN(n));
      if (values.length < 2) return "";
      const min = Math.min.apply(null, values);
      const max = Math.max.apply(null, values);
      const span = max - min || 1;
      return values
        .map((v, i) => {
          const x = (i / (values.length - 1)) * width;
          const y = height - ((v - min) / span) * (height - 2) - 1;
          return x + "," + y;
        })
        .join(" ");
    },
    volumeOf(item) {
      return Number(item.volume || item.cje || item.turnover || item.amount || 0);
    },
    getListMarketByType() {
      const tabs = this.marketTabList;
      Promise.all(
        tabs.map((tab) =>
          listMarketByType({ type: tab.value })
            .then((res) => {
              const list = (res && res.result) || [];
              return {
                type: tab.value,
                list: (Array.isArray(list) ? list : []).map((item) => this.normalizeItem(item))
              };
            })
            .catch(() => ({ type: tab.value, list: [] }))
        )
      ).then((groups) => {
        const next = {};
        groups.forEach((group) => {
          next[group.type] = group.list;
        });
        this.marketByType = next;
        const cryptoIndex = tabs.findIndex((tab) => tab.value === "2");
        if (cryptoIndex >= 0 && (next["2"] || []).length) {
          this.markTypeIndex = cryptoIndex;
        }
      });
    },
    toggleGroup(key) {
      this.openGroup = this.openGroup === key ? "" : key;
    },
    goFooter(link) {
      if (link.type === "service") {
        openCustomerService(this);
        return;
      }
      if (link.type === "cms") {
        this.$router.push({ path: "/detail", query: { id: link.item.id, title: link.item.title } });
        return;
      }
      if (link.path) this.$router.push(link.path);
    }
  }
};
</script>
<style scoped>
.bb-home-m {
  background: var(--bb-bg);
  color: var(--bb-text);
}
.bb-home-main {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 16px;
}
.bb-m-hero {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.bb-m-logged {
  padding: 24px 16px 0;
  display: flex;
  flex-direction: column;
  gap: 28px;
}
.bb-m-asset {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.bb-m-asset-copy {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.bb-m-asset-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  line-height: 1.4;
  color: var(--bb-text-tertiary);
}
.bb-m-asset-label button {
  display: inline-flex;
  width: 14px;
  height: 14px;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  cursor: pointer;
}
.bb-m-asset-value {
  display: flex;
  align-items: baseline;
  gap: 4px;
  min-height: 42px;
  font-weight: 700;
  color: var(--bb-text);
}
.bb-m-asset-value span {
  font-size: 30px;
  line-height: 1.2;
}
.bb-m-asset-value em {
  font-style: normal;
  font-size: 12px;
  font-weight: 500;
  color: var(--bb-text-tertiary);
}
.bb-m-add {
  height: 32px;
  flex-shrink: 0;
  padding: 0 16px;
  border: 0;
  border-radius: 999px;
  background: var(--bb-brand);
  color: var(--bb-always-black);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.bb-m-entries {
  display: flex;
  gap: 8px;
}
.bb-m-entries button {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: 0;
  background: none;
  color: var(--bb-text);
  cursor: pointer;
}
.bb-m-entries img,
.bb-m-entries svg {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.bb-m-entries span {
  width: 100%;
  font-size: 11px;
  line-height: 1.4;
  text-align: center;
}
.bb-m-banner {
  position: relative;
  margin-top: 12px;
  height: 190px;
  overflow: hidden;
}
.bb-m-banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: bottom;
}
.bb-m-fade {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60px;
  background: linear-gradient(to bottom, transparent, var(--bb-bg));
  pointer-events: none;
}
.bb-m-copy {
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.bb-m-titles {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.bb-m-copy h1 {
  margin: 0;
  font-size: 18px;
  line-height: 1.4;
  font-weight: 700;
  text-align: center;
}
.bb-m-copy p {
  margin: 0;
  width: 100%;
  font-size: 12px;
  line-height: 1.4;
  color: var(--bb-text-secondary);
  text-align: center;
}
.bb-m-copy p img {
  width: 14px;
  height: 14px;
  vertical-align: middle;
  margin-right: 4px;
  filter: var(--bb-mono-invert);
}
.bb-m-gift {
  margin: 0 4px;
  font-weight: 700;
  color: var(--bb-brand);
  white-space: nowrap;
}
.bb-m-copy button {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 999px;
  background: var(--bb-brand);
  color: var(--bb-always-black);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.bb-m-ticker {
  padding: 0 16px;
}
.bb-m-ticker-grid {
  height: 130px;
  border-radius: 12px;
  background: var(--bb-bg-card);
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  overflow: hidden;
}
.bb-m-ticker-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  min-width: 0;
  cursor: pointer;
}
.bb-m-ticker-item:nth-child(1),
.bb-m-ticker-item:nth-child(2) {
  border-bottom: 1px solid var(--bb-divider);
}
.bb-m-ticker-item:nth-child(odd) {
  border-right: 1px solid var(--bb-divider);
}
.bb-m-ticker-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.bb-m-ticker-meta {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  max-width: 104px;
  overflow: hidden;
}
.bb-m-ticker-meta span {
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.4;
}
.bb-m-ticker-meta p {
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 10px;
  line-height: 1.4;
  color: var(--bb-text-tertiary);
}
.bb-m-spark {
  flex-shrink: 0;
}
.bb-m-ticker-bottom {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}
.bb-m-ticker-price {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
}
.bb-m-ticker-bottom .bb-chg {
  font-size: 10px;
}
.bb-m-board {
  padding: 0;
}
.bb-m-ranks {
  display: flex;
  flex-direction: column;
}
.bb-m-rank-tabs,
.bb-m-type-tabs {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding: 0 16px;
  scrollbar-width: none;
}
.bb-m-rank-tabs::-webkit-scrollbar,
.bb-m-type-tabs::-webkit-scrollbar {
  display: none;
}
.bb-m-rank-tabs button,
.bb-m-type-tabs button {
  flex-shrink: 0;
  background: transparent;
  border: 0;
  color: var(--bb-text-tertiary);
  cursor: pointer;
  padding: 10px 0;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
}
.bb-m-rank-tabs button.active {
  color: var(--bb-text);
  font-weight: 700;
}
.bb-m-type-tabs {
  margin-bottom: 16px;
  border-bottom: 1px solid var(--bb-divider);
}
.bb-m-type-tabs button {
  position: relative;
  height: 40px;
  font-size: 12px;
  padding: 9px 0;
}
.bb-m-type-tabs button.active {
  color: var(--bb-text);
  font-weight: 700;
}
.bb-m-type-tabs button.active::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 16px;
  height: 2px;
  border-radius: 999px;
  background: var(--bb-text);
  transform: translateX(-50%);
}
.bb-m-table {
  padding: 0 16px;
}
.bb-m-thead {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(72px, 0.8fr) 72px;
  align-items: center;
  height: 32px;
  color: var(--bb-text-tertiary);
  font-size: 12px;
}
.bb-m-thead span:nth-child(2),
.bb-m-thead span:nth-child(3) {
  text-align: right;
}
.bb-m-trow {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(72px, 0.8fr) 72px;
  align-items: center;
  height: 62px;
  cursor: pointer;
  column-gap: 8px;
}
.bb-m-pair {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.bb-m-pair img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-shrink: 0;
}
.bb-m-pair-name {
  font-size: 14px;
  font-weight: 500;
}
.bb-m-pair-name span,
.bb-m-pair p,
.bb-m-last span {
  color: var(--bb-text-tertiary);
  font-size: 12px;
  font-weight: 400;
}
.bb-m-pair p,
.bb-m-last p {
  margin: 0;
}
.bb-m-last {
  text-align: right;
}
.bb-m-last p {
  font-size: 14px;
  font-weight: 500;
}
.bb-m-pill {
  width: 72px;
  height: 30px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: var(--bb-text);
  background: var(--bb-pill);
  justify-self: end;
}
.bb-m-pill.up {
  background: var(--bb-up);
  color: var(--bb-always-white);
}
.bb-m-pill.down {
  background: var(--bb-down);
  color: var(--bb-always-white);
}
.bb-m-more {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 0 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.bb-chg {
  color: var(--bb-text-tertiary);
}
.bb-chg.up {
  color: var(--bb-up);
}
.bb-chg.down {
  color: var(--bb-down);
}
.bb-m-footer {
  padding: 48px 16px 24px;
  color: var(--bb-text);
}
.bb-m-footer-brand {
  color: var(--bb-text);
  margin-bottom: 36px;
  display: inline-block;
}
.bb-m-acc-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  background: transparent;
  border: none;
  color: var(--bb-text);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}
.bb-m-acc-btn svg {
  color: var(--bb-text-tertiary);
  transition: transform 0.2s;
}
.bb-m-acc-btn svg.open {
  transform: rotate(180deg);
}
.bb-m-acc-body {
  display: flex;
  flex-direction: column;
  padding-bottom: 8px;
}
.bb-m-acc-body a {
  color: var(--bb-text-tertiary);
  font-size: 14px;
  padding: 10px 0;
  cursor: pointer;
}
.bb-m-copy {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid var(--bb-divider);
  text-align: center;
  font-size: 12px;
  color: var(--bb-text-tertiary);
}
</style>
